/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2017 Pearson Education, Inc.
( * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import {
    getLocalStorage,
    getSessionStorage,
    removeLocalStorage,
    removeSessionStorage
} from './_helpers/localStorage.helper';

import {getLoginTokenSuccess} from "./_actions/home.actions";
import {refreshSession, userLogin} from "./_thunks/login.thunk";

import config from './config/config';
import {decrypt} from "./_helpers/crypto.helper";

export function sessionLogout () {
    window.piSession.logout();
}

export function sessionLogin (payload) {
    const loginObj = payload;
    window.piSession.autologin(loginObj.username, loginObj.password, config.pi.clientId, getRedirectURL());
}

function getRedirectURL () {
    return window.location.href;
}

function getLoginFailRedirectURL () {
    return window.location.origin + "/admintool";
}

export default function init (store) {
    let piSession = window.piSession;
    getRedirectURL();

    piSession.initialize(config.pi.clientId, {
        checkSessionMilliseconds: 3000,
        sessionIdleTimeoutSeconds: 400000
    });

    piSession.on(piSession.RefreshEvent, () => {
        piSession.getToken((status, token) => {
            switch (status) {
                case 'success': {
                    store.dispatch(refreshSession(token));
                    break;
                }
                default : {
                    // sessionLogin();
                }
            }
        });
    });

    piSession.on(piSession.SessionStateKnownEvent, (evt) => {
        piSession.getToken((status, token) => {
            switch (status) {
                case 'success': {
                    store.dispatch(getLoginTokenSuccess(token));
                    store.dispatch(userLogin(token));
                    break;
                }
                case 'notoken' : {
                    let loginObj;
                    if (process.env.NODE_ENV === "development") {
                        loginObj = {username: "ps1_ganu", password: "Passw0rd"};
                        sessionLogin(loginObj);
                    } else {
                        loginObj = JSON.parse(getLocalStorage('__amplify__adminlogin'));
                        if (loginObj) {
                            sessionLogin(JSON.parse(decrypt(loginObj.data)));
                        } else {
                            window.location.replace(getLoginFailRedirectURL());
                        }
                    }
                    break;
                }
                default : {
                    break;
                }
            }
        });
    });
}



// WEBPACK FOOTER //
// ./src/session.initialize.js